
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/sentry.client.config.ts")
            }
          });